import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/**
 * Eyebrow pill + headline + supporting copy, used by each home page section.
 */
const SectionHeading = ({ icon, eyebrow, title, subtitle }) => (
  <Box sx={{ textAlign: "center", maxWidth: 720, mx: "auto" }}>
    {eyebrow && (
      <Box
        sx={(theme) => ({
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          px: 1.5,
          py: 0.75,
          mb: 2.5,
          borderRadius: "10px",
          border: theme.tokens.tag.border,
          backgroundColor: theme.tokens.tag.background,
          fontSize: "0.8rem",
          fontWeight: 600,
          letterSpacing: "0.02em",
          "& svg": { fontSize: "1rem" },
        })}
      >
        {icon}
        {eyebrow}
      </Box>
    )}

    <Typography variant="h2" sx={{ mb: 2, textWrap: "balance" }}>
      {title}
    </Typography>

    {subtitle && (
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 4, maxWidth: "60ch", mx: "auto" }}
      >
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default SectionHeading;
